
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as testgF8YVcEvNFgdAGVe6df_ffWCYwjmpFN5bnDmV8HIlgQMeta } from "/var/www/sharun-store/drive/pages/test.vue?macro=true";
import { default as aboutmBlo6gDdAof_45L2zQ5XFeByCM9rQ8TrhGYoWYegUdfoIMeta } from "/var/www/sharun-store/drive/pages/about.vue?macro=true";
import { default as driveOPGCz8A3BKEKKc1A48KNHDKEZwz_45CUsVzkAFeQeenfUMeta } from "/var/www/sharun-store/drive/pages/drive.vue?macro=true";
import { default as indexzGDFcDi3_uijc3AszvhDvaXn_eVl0DnVnwkOHLXvErIMeta } from "/var/www/sharun-store/drive/pages/index.vue?macro=true";
import { default as spaceptLOQHfbJ4mZnurSOBViMgL8W_SAdfStRGNqGMMJeRoMeta } from "/var/www/sharun-store/drive/pages/space.vue?macro=true";
import { default as style9JGMLd64Sp1wnkpbeXYA8dr_45AI5GOvaG9pn_oYLDqbYMeta } from "/var/www/sharun-store/drive/pages/style.vue?macro=true";
import { default as basket_45C_45cPUfKP7XMRcPtcGYfh_45dlR8MHpFxR1RUckF0lBz4Meta } from "/var/www/sharun-store/drive/pages/basket.vue?macro=true";
import { default as choice_Oo6nzTOKzQqzw1w642ExCNSD3uRz_45hqhwa2vNlvqYsMeta } from "/var/www/sharun-store/drive/pages/choice.vue?macro=true";
import { default as ofertaCSF2kbCL5Tl2CPqfXIsMqVwvzysi7zAn_45aq9_7S1elAMeta } from "/var/www/sharun-store/drive/pages/oferta.vue?macro=true";
import { default as ordersMmb75E543_bYCPenw80SicB98XVF4to7k77lqt3zw2gMeta } from "/var/www/sharun-store/drive/pages/orders.vue?macro=true";
import { default as accountmUBO7QWAOrTBIFihvHt_SrdTSjYzCrJ0nW19zxEvxNwMeta } from "/var/www/sharun-store/drive/pages/account.vue?macro=true";
import { default as adagreedSrscZgOri777NIHn0V5G5NqnD_451CEMhdZRTha1yWQ0Meta } from "/var/www/sharun-store/drive/pages/adagree.vue?macro=true";
import { default as catalogBDG1zockQbsEWQzylX1OX8ZNQvCiPw3JBrzcbpGMM34Meta } from "/var/www/sharun-store/drive/pages/catalog.vue?macro=true";
import { default as gallery8PPjDWp55nVJUo2xbL9XhdJOH99HXnwO1WPhWiC_45zZ8Meta } from "/var/www/sharun-store/drive/pages/gallery.vue?macro=true";
import { default as paymenthgiR0BfHN_4530LWSHfrra5U5GEq3Wwn5DxyxL3HoXTbEMeta } from "/var/www/sharun-store/drive/pages/payment.vue?macro=true";
import { default as privacytq6YFaLilP_jCIdvGuYVNULQDO0L8UXr4Ju69nSvHnAMeta } from "/var/www/sharun-store/drive/pages/privacy.vue?macro=true";
import { default as returnsdZgnIw0mnLerDXO57qen9rGSZI9esKGEXMnr3vLOFkMMeta } from "/var/www/sharun-store/drive/pages/returns.vue?macro=true";
import { default as successw2MHkkM6V9iFI8bMOxiNpunigwazrZxaZNriB9xndjcMeta } from "/var/www/sharun-store/drive/pages/success.vue?macro=true";
import { default as contactsSZt1iRB6n59fJwTmLduTvF5j10_Tkt7bHbw22f71Yl8Meta } from "/var/www/sharun-store/drive/pages/contacts.vue?macro=true";
import { default as deliverykzP7Fiu41Qi1aCrXzkKDuayqMwn3JYaYtDgHx9g_n_45MMeta } from "/var/www/sharun-store/drive/pages/delivery.vue?macro=true";
import { default as requestsa1j_45cBALQurIAWRIIDcRllOFTpvMw_45WVV7lyr2C58yAMeta } from "/var/www/sharun-store/drive/pages/requests.vue?macro=true";
import { default as agreementVJ5k4wbsbE5Qwd2wNy7tsugVawgaVy7E9h7PpZeIp8oMeta } from "/var/www/sharun-store/drive/pages/agreement.vue?macro=true";
import { default as teste0xuZFoH7WedOhqWDLggQjK3MVZ6OstP_45jBC_45Sono7QMeta } from "/var/www/sharun-store/drive/pages/list/test.vue?macro=true";
import { default as toauthorsowqx_GKxqqkKEhGp4RNHetrlMueir1K3aO_45O49Fr8XAMeta } from "/var/www/sharun-store/drive/pages/toauthors.vue?macro=true";
import { default as _91id_934V6zbyrm7sVfhV_45KJLI7JyohAQa33Syg95_45WD80v0fgMeta } from "/var/www/sharun-store/drive/pages/vibe/[id].vue?macro=true";
import { default as deliveries_45WFC8aLxUMORCeEmXngWSwHH2LNk2q5ISiQSiyofv94Meta } from "/var/www/sharun-store/drive/pages/deliveries.vue?macro=true";
import { default as _91id_93oFz0FIKb37S2P777xJnBx_D_YSqXPvsts5bh3JTDcjwMeta } from "/var/www/sharun-store/drive/pages/image/[id].vue?macro=true";
import { default as _42qDCOqF8Dyb6tiGp8nevLdghWiIKsVrYJYcaXJton_45iwMeta } from "/var/www/sharun-store/drive/pages/product/42.vue?macro=true";
import { default as _44_bOoxMOV0XHAk3wYgFu4h2LswYcJ0HcExw6CFR80ZukMeta } from "/var/www/sharun-store/drive/pages/product/44.vue?macro=true";
import { default as _47FozghwJPhvoRXBvUjsR3GiWN0LBXXStiZMo_45cTU9bbsMeta } from "/var/www/sharun-store/drive/pages/product/47.vue?macro=true";
import { default as _91slug_9309sapl2oJeXtZwXzlYGqZigtcAAnYZkI8R1ElNLD2tAMeta } from "/var/www/sharun-store/drive/pages/set/[slug].vue?macro=true";
import { default as topartners2ABpAK1bsewEzIh3sujxP9TKVGJWVE0fVzmqe5rP5qMMeta } from "/var/www/sharun-store/drive/pages/topartners.vue?macro=true";
import { default as _91hash_93u_WufUYHMX4B6QMgnn0FwBz8HDmN7tGx8p3K2JC6wDIMeta } from "/var/www/sharun-store/drive/pages/vin/[hash].vue?macro=true";
import { default as _91id_93nFLTKStVth1tmukqfYBila4XZUJDR0nJym_45GLjzkvZoMeta } from "/var/www/sharun-store/drive/pages/product/[id].vue?macro=true";
import { default as _91id_93Q2xr1uEQo6pz8kPVl_45nix9WEfwh_45_TcFLQvK6RDK7rgMeta } from "/var/www/sharun-store/drive/pages/galleries/[id].vue?macro=true";
import { default as _91direction_930a3JJmSJcXP2F4miBIqUBS7M37VYRLyowfRc5YHGw00Meta } from "/var/www/sharun-store/drive/pages/partner/[slug]/[direction].vue?macro=true";
import { default as _91slug_93t55T2r_4513zHilYi_45e10K14c908PoKH5dlXzbCN6vXwsMeta } from "/var/www/sharun-store/drive/pages/partner/[slug].vue?macro=true";
import { default as _91id_934u3VPn7wSYhTzzJIVtDRKwcZG15I7fsbRf4qVvua_45zQMeta } from "/var/www/sharun-store/drive/pages/collection/[id].vue?macro=true";
import { default as index_45zaglushkaUF2MH9PASU9UXNYiaGucOw80BCxLSKb0mJNp6F8gYqYMeta } from "/var/www/sharun-store/drive/pages/index-zaglushka.vue?macro=true";
import { default as digital_45productsJIHt09W8R4P346v_45UbbWD3sI3LhJuj3v7ogylqripvwMeta } from "/var/www/sharun-store/drive/pages/digital-products.vue?macro=true";
import { default as _91id_93I0ycXAzzn3PxvMtWWZzR9AJCaGLbpZq2mUHg3a0xL8YMeta } from "/var/www/sharun-store/drive/pages/real-estate/[id].vue?macro=true";
import { default as indexJpKUQ65MK5eom6uw_45yq8loifPAwG1NLz4llRFQyOJ68Meta } from "/var/www/sharun-store/drive/pages/realestate/index.vue?macro=true";
import { default as indexUsT3K7Qo2XNMQt8RWJvf_45B7qYEBDGA8UHFwYbgadHZcMeta } from "/var/www/sharun-store/drive/pages/realestate/region/index.vue?macro=true";
import { default as _91id_93FgDpnPnxUfP3SvkbEDcibyZ6ICx_6tD1AMKsQkx5TI0Meta } from "/var/www/sharun-store/drive/pages/real-estate/project/[id].vue?macro=true";
import { default as _91slug_93S70DuAjbBGX9y_MG6z5kcey7vq_45QH5k_vJJUt0_45HdK4Meta } from "/var/www/sharun-store/drive/pages/realestate/region/[slug].vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    component: () => import("/var/www/sharun-store/drive/pages/test.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/var/www/sharun-store/drive/pages/about.vue")
  },
  {
    name: "drive",
    path: "/drive",
    component: () => import("/var/www/sharun-store/drive/pages/drive.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/sharun-store/drive/pages/index.vue")
  },
  {
    name: "space",
    path: "/space",
    component: () => import("/var/www/sharun-store/drive/pages/space.vue")
  },
  {
    name: "style",
    path: "/style",
    component: () => import("/var/www/sharun-store/drive/pages/style.vue")
  },
  {
    name: "basket",
    path: "/basket",
    component: () => import("/var/www/sharun-store/drive/pages/basket.vue")
  },
  {
    name: "choice",
    path: "/choice",
    component: () => import("/var/www/sharun-store/drive/pages/choice.vue")
  },
  {
    name: "oferta",
    path: "/oferta",
    component: () => import("/var/www/sharun-store/drive/pages/oferta.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/var/www/sharun-store/drive/pages/orders.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/var/www/sharun-store/drive/pages/account.vue")
  },
  {
    name: "adagree",
    path: "/adagree",
    component: () => import("/var/www/sharun-store/drive/pages/adagree.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/var/www/sharun-store/drive/pages/catalog.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/var/www/sharun-store/drive/pages/gallery.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/var/www/sharun-store/drive/pages/payment.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/var/www/sharun-store/drive/pages/privacy.vue")
  },
  {
    name: "returns",
    path: "/returns",
    component: () => import("/var/www/sharun-store/drive/pages/returns.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/sharun-store/drive/pages/success.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/var/www/sharun-store/drive/pages/contacts.vue")
  },
  {
    name: "delivery",
    path: "/delivery",
    component: () => import("/var/www/sharun-store/drive/pages/delivery.vue")
  },
  {
    name: "requests",
    path: "/requests",
    meta: requestsa1j_45cBALQurIAWRIIDcRllOFTpvMw_45WVV7lyr2C58yAMeta || {},
    component: () => import("/var/www/sharun-store/drive/pages/requests.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/var/www/sharun-store/drive/pages/agreement.vue")
  },
  {
    name: "list-test",
    path: "/list/test",
    component: () => import("/var/www/sharun-store/drive/pages/list/test.vue")
  },
  {
    name: "toauthors",
    path: "/toauthors",
    component: () => import("/var/www/sharun-store/drive/pages/toauthors.vue")
  },
  {
    name: "vibe-id",
    path: "/vibe/:id()",
    component: () => import("/var/www/sharun-store/drive/pages/vibe/[id].vue")
  },
  {
    name: "deliveries",
    path: "/deliveries",
    component: () => import("/var/www/sharun-store/drive/pages/deliveries.vue")
  },
  {
    name: "image-id",
    path: "/image/:id()",
    component: () => import("/var/www/sharun-store/drive/pages/image/[id].vue")
  },
  {
    name: "product-42",
    path: "/product/42",
    component: () => import("/var/www/sharun-store/drive/pages/product/42.vue")
  },
  {
    name: "product-44",
    path: "/product/44",
    component: () => import("/var/www/sharun-store/drive/pages/product/44.vue")
  },
  {
    name: "product-47",
    path: "/product/47",
    component: () => import("/var/www/sharun-store/drive/pages/product/47.vue")
  },
  {
    name: "set-slug",
    path: "/set/:slug()",
    component: () => import("/var/www/sharun-store/drive/pages/set/[slug].vue")
  },
  {
    name: "topartners",
    path: "/topartners",
    component: () => import("/var/www/sharun-store/drive/pages/topartners.vue")
  },
  {
    name: "vin-hash",
    path: "/vin/:hash()",
    component: () => import("/var/www/sharun-store/drive/pages/vin/[hash].vue")
  },
  {
    name: "product-id",
    path: "/product/:id()",
    component: () => import("/var/www/sharun-store/drive/pages/product/[id].vue")
  },
  {
    name: "galleries-id",
    path: "/galleries/:id()",
    component: () => import("/var/www/sharun-store/drive/pages/galleries/[id].vue")
  },
  {
    name: "partner-slug",
    path: "/partner/:slug()",
    component: () => import("/var/www/sharun-store/drive/pages/partner/[slug].vue"),
    children: [
  {
    name: "partner-slug-direction",
    path: ":direction()",
    component: () => import("/var/www/sharun-store/drive/pages/partner/[slug]/[direction].vue")
  }
]
  },
  {
    name: "collection-id",
    path: "/collection/:id()",
    component: () => import("/var/www/sharun-store/drive/pages/collection/[id].vue")
  },
  {
    name: "index-zaglushka",
    path: "/index-zaglushka",
    meta: index_45zaglushkaUF2MH9PASU9UXNYiaGucOw80BCxLSKb0mJNp6F8gYqYMeta || {},
    component: () => import("/var/www/sharun-store/drive/pages/index-zaglushka.vue")
  },
  {
    name: "digital-products",
    path: "/digital-products",
    component: () => import("/var/www/sharun-store/drive/pages/digital-products.vue")
  },
  {
    name: "real-estate-id",
    path: "/real-estate/:id()",
    component: () => import("/var/www/sharun-store/drive/pages/real-estate/[id].vue")
  },
  {
    name: "realestate",
    path: "/realestate",
    component: () => import("/var/www/sharun-store/drive/pages/realestate/index.vue")
  },
  {
    name: "realestate-region",
    path: "/realestate/region",
    component: () => import("/var/www/sharun-store/drive/pages/realestate/region/index.vue")
  },
  {
    name: "real-estate-project-id",
    path: "/real-estate/project/:id()",
    component: () => import("/var/www/sharun-store/drive/pages/real-estate/project/[id].vue")
  },
  {
    name: "realestate-region-slug",
    path: "/realestate/region/:slug()",
    component: () => import("/var/www/sharun-store/drive/pages/realestate/region/[slug].vue")
  },
  {
    name: "category",
    path: "/catalog/:id",
    component: () => import("/var/www/sharun-store/drive/pages/catalog.vue")
  }
]